/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MonitoringStatusItemList } from '../../models/monitoring-status-item-list';

export interface MonitoringControllerGetAllStatuses$Params {
}

export function monitoringControllerGetAllStatuses(http: HttpClient, rootUrl: string, params?: MonitoringControllerGetAllStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringStatusItemList;
}>> {
  const rb = new RequestBuilder(rootUrl, monitoringControllerGetAllStatuses.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MonitoringStatusItemList;
      }>;
    })
  );
}

monitoringControllerGetAllStatuses.PATH = '/monitoring/statuses';
